"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SkeletonList = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const uuid_1 = __importDefault(require("../utils/uuid"));
const SkeletonItem = () => (react_1.default.createElement("li", { "aria-hidden": "true", className: "skeleton-item" },
    react_1.default.createElement("div", { className: "skeleton-item__container skeleton-item__animate" },
        react_1.default.createElement("span", { className: "skeleton-item__icon" }),
        react_1.default.createElement("div", { className: "skeleton-item__body" },
            react_1.default.createElement("div", { className: "skeleton-item__text" }),
            react_1.default.createElement("div", { className: "skeleton-item__text" })),
        react_1.default.createElement("div", { className: "skeleton-item__link" }))));
const SkeletonList = (props) => {
    const { itemCount = 8, className, ariaLabel } = props;
    return (react_1.default.createElement("ul", { className: (0, clsx_1.default)(`skeleton-list`, className), "aria-label": `${ariaLabel || 'Loading'}` }, [...Array(itemCount)].map((_item) => {
        return react_1.default.createElement(SkeletonItem, { key: (0, uuid_1.default)() });
    })));
};
exports.SkeletonList = SkeletonList;
